import React, { FC } from 'react'
import styled from 'styled-components'
import { calculateBagInDollar } from '../../../logic/financials/calculate-bag-in-dollar'
import { minus } from '../../../utils/static-web3'
import { usePools } from '../../../hooks/use-pools'
import { useNavigate } from 'react-router-dom'
import { WithdrawPopup } from '../withdraw/WithdrawPopup'
import { EmptyLine } from '../../catalog/EmptyLine'
import { SwaapLargeLoader } from '../../catalog/SwaapLoader'
import { DepositPageWrapper } from './DepositPage'
import { InjectedWindow } from '../../../utils/types'

const WithdrawPageWrapper = styled.div``

export interface Props {
  poolId: string
}
declare const window: InjectedWindow

export const WithdrawPage: FC<Props> = ({ poolId }) => {
  const { pools } = usePools()

  const selectedLine = pools.find(p => p.pool.address === poolId)
  if (selectedLine) {
    window.applicationContext.selectedPool = selectedLine.pool
  }
  const navigate = useNavigate()
  if (!selectedLine) {
    return (
      <DepositPageWrapper>
        <EmptyLine block />
        <EmptyLine block />
        <SwaapLargeLoader />
      </DepositPageWrapper>
    )
  }
  return (
    <WithdrawPageWrapper>
      <EmptyLine block />

      <WithdrawPopup
        line={selectedLine}
        onExit={() => {
          navigate('/')
        }}
        onWithdraw={async (userShareExit, amounts, all) => {
          const value = await calculateBagInDollar(amounts)
          const currentValue = selectedLine!.userValue || 0
          const currentTvl = selectedLine!.tvl || 0
          selectedLine!.userValue = all ? 0 : Math.max(0, currentValue - value)
          selectedLine!.userShares = all
            ? '0'
            : minus(selectedLine!.userShares!, userShareExit)
          selectedLine!.tvl = currentTvl - value
        }}
        pool={selectedLine.pool}
      />
    </WithdrawPageWrapper>
  )
}
